<template>
  <simple-modal
    :open.sync="openModal"
    title="E-Mail Authorisierung abgelaufen"
    no-backdrop-dismiss
    content-css="width: 800px"
  >
    <div slot="body" class="q-pa-sm">
      <div class="row">
        <q-alert
          class="full-width"
          type="warning"
        >
          <b>Aktion erforderlich</b> <br><br>
          Die Autorisierung Ihrer E-Mail-Verbindung ist abgelaufen. Bitte autorisieren Sie sich erneut.
        </q-alert>
      </div>
    </div>

    <template slot="footer">
      <div class="row justify-end">
        <q-btn
          no-caps
          outline
          class="q-mr-sm"
          :loading="loading"
          label="Authorisierung aufheben"
          @click="revokeEmailConnection" />

        <q-btn
          no-caps
          color="primary"
          class="no-shadow"
          label="Erneut authorisieren"
          @click="reauthorize" />

      </div>
    </template>

  </simple-modal>

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SimpleModal from '@/components/base/SimpleModal';
import { modal } from '@/plugins/mixins';

export default {
  name: 'EmailReconnectModal',

  components: {
    SimpleModal,
  },
  computed: {
    ...mapGetters('auth', ['getBranchNylasAddress']),
  },

  data() {
    return {
      loading: false,
      openModal: this.isOpen,
    };
  },
  mixins: [modal],

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('emailThreadDetail', ['revokeEmail']),
    ...mapActions('auth', ['reloadCurrentBranch']),
    reauthorize() {
      const params = {
        client_id: 'd5e1b7ce-6b53-435a-b708-9ad4d2d8851c',
        response_type: 'code',
        access_type: 'online',
        redirect_uri: process.env.VUE_APP_NYLAS_REDIRECT_URI,
        login_hint: this.getBranchNylasAddress,
        prompt: 'detect,select_provider',
      };

      const queryString = new URLSearchParams(params).toString();
      const url = `https://api.eu.nylas.com/v3/connect/auth?${queryString}`;

      window.open(url, '_self');
    },
    async revokeEmailConnection() {
      this.loading = true;
      await this.revokeEmail();
      this.$notifyUserInteraction.success('Autorisierung aufgehoben!');
      this.reloadCurrentBranch();
      this.loading = false;
      this.openModal = false;
    },
  },
};
</script>

<style lang="stylus" scoped>

</style>
